module.exports = __webpack_public_path__ + "img/img_account.982285bc.png";